export default function lineKeyReducer(lineKey, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "type":
      return { ...lineKey, type: action.value, label: "", value: "" };
    case "value":
      return { ...lineKey, value: action.value, label: action?.label || lineKey.label };

    default:
      return { ...lineKey, [action.type]: action.value };
  }
}
